import { defineComponent as _defineComponent } from 'vue'
import { onBeforeMount } from 'vue'
import YagiChatBot from '@/components/format-edit/yagi-chat-bot/YagiChatBot.vue'
import { useShibouDoukishoAi } from '@/composables/format-edit/useShibouDoukishoAi'
import { useShibouDoukishoFormatData } from '@/composables/format-edit/useShibouDoukishoFormatData'
import shibouDoukishoAiQuestions from '@/utils/format-edit/shibouDoukishoAiQuestions.json'
import type {
  YagiChatFormValue,
  YagiChatQuestion
} from '@/utils/format-edit/yagiChatBot'


export default /*#__PURE__*/_defineComponent({
  __name: 'ShibouDoukishoReasonCard',
  props: {
    currentCardId: null,
    previewErrors: null
  },
  setup(__props: any) {



const formatData = useShibouDoukishoFormatData()
const aiQuestions = shibouDoukishoAiQuestions as YagiChatQuestion[]

const {
  chatBot,
  fullscreenLoading,
  loadingText,
  aiUsageCount,
  aiMaxUsageCount,
  globalVar,
  generateAiMypr,
  applyAiResult,
  openReasonLongChat,
  goYagiprimeRegister,
  fetchAiUsageCount,
  autoFillFromRirekisho
} = useShibouDoukishoAi(formatData)

onBeforeMount(() => {
  autoFillFromRirekisho()
  fetchAiUsageCount()
})

function onChatInput(next: YagiChatFormValue) {
  Object.assign(formatData, next)
}

return { __sfc: true,formatData, aiQuestions, chatBot, fullscreenLoading, loadingText, aiUsageCount, aiMaxUsageCount, globalVar, generateAiMypr, applyAiResult, openReasonLongChat, goYagiprimeRegister, fetchAiUsageCount, autoFillFromRirekisho, onChatInput, YagiChatBot }
}

})